<template>
  <div id="main">
    <div class="info">
      <div class="info-item" v-if="currentCompany.credentialType">
        <p class="info-head">{{ $t('当前信息') }}</p>
        <ul>
          <li>
            <span class="info-txt">{{ $t('用户ID：') }}</span>
            <span class="info-value">{{ currentCompany.gid }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('账号名称：') }}</span>
            <span class="info-value">{{ currentCompany.name }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('证件类型：') }}</span>
            <span class="info-value">{{ currentCompany.credentialType }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('证件号：') }}</span>
            <span class="info-value">{{ currentCompany.credentialValue }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('联系地址：') }}</span>
            <span class="info-value">{{ currentCompany.address }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('联系电话：') }}</span>
            <span class="info-value">{{ currentCompany.mobile }}</span>
          </li>
        </ul>
      </div>
      <div class="info-item" v-if="!currentCompany.credentialType">
        <p class="info-head">{{ $t('当前信息') }}</p>
        <ul>
          <li>
            <span class="info-txt">{{ $t('用户ID：') }}</span>
            <span class="info-value">{{ currentCompany.gid }}</span>
          </li>
          <li>
            <span class="info-txt">{{ $t('姓名：') }}</span>
            <span class="info-value">{{ currentCompany.name }}</span>
          </li>
        </ul>
      </div>
      <es-button type="primary" @click="jump()">{{ $t('进入统一用户中心') }}<i class="es-icon-arrow-right"></i></es-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {},
  computed: {
    ...mapState({
      currentCompany: state => state.currentCompany,
    }),
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    jump() {
      window.open(this.$Dic.getDefaultURL().userUrl)
    },
  },
}
</script>
<style lang="less" scoped>
.info {
  padding: 60px 0;
  width: 83%;
  margin: 0 auto;
  &-item {
    margin-bottom: 30px;
  }
  &-head {
    font-size: 20px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    padding-bottom: 20px;
    margin-bottom: 30px;
    border-bottom: 1px solid rgba(243, 243, 243, 1);
  }
  li {
    padding-bottom: 30px;
    display: flex;
    align-items: center;
  }
  &-value {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-right: 50px;
  }
  &-sign {
    margin-left: -40px;
    width: 52px;
    height: 20px;
    background: linear-gradient(158deg, rgba(255, 163, 101, 0.87) 0%, rgba(230, 99, 23, 1) 100%);
    border-radius: 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
    text-align: center;
  }
  &-txt {
    width: 95px;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }
}
</style>
